import { useGetUnreadNotificationsCountQuery } from 'tradera/apps/tradera/components/notifications-side-sheet/notifications-api';
import { HeaderBadge } from 'tradera/components/site-header/header-badge';

export const NotificationsBadge = () => {
    const { data: unreadNotificationsCount = 0 } =
        useGetUnreadNotificationsCountQuery();

    return unreadNotificationsCount > 0 ? (
        <HeaderBadge count={unreadNotificationsCount} />
    ) : null;
};
